import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class NotificationAlreadySentError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotificationAlreadySentError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class ChallengeAlreadyExistError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ChallengeAlreadyExistError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    UnauthorizedError,
    NotificationAlreadySentError,
    ForbiddenError,
    ChallengeAlreadyExistError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
